



































import { Component, Vue, Watch, Prop } from "vue-property-decorator";

import ModalTabs from "../../DashboardLayoutComponents/ModalTabs.vue";
import FormField from "../../DashboardLayoutComponents/FormField.vue";
import EspressoAux from '../../../components/Espresso/EspressoAux.vue';

import userModel from "@/models/user.model"
import specialtyModel from "@/models/specialty.model";
import sectorModel from "@/models/sector.model";

@Component({
	components: { ModalTabs, FormField },
})
export default class UserModal extends Vue {
	tabs = [
		{ icon: "edit", name: "Dados" },
		{ icon: "work", name: "Setores" },
		{ icon: "delete", name: "Excluir" },
	];
	schema: any = [];
	entity: any = { userSectors: [] };
	loading = false;
	error = "";
	sectorModel: any;
	specialtyModel: any;

	@Prop({ required: true })
	private userId: any;

	constructor() {
		super();
		this.specialtyModel = specialtyModel;
		this.sectorModel = sectorModel;
	}

	private async mounted() {
		this.loading = true;
		try {
			this.schema = await userModel.getDescription();
			await this.readEntity(this.userId);
		} catch (error) {
			console.error(error);
		}
		this.loading = false;
	}

	updateNotes(notes: string) {
		this.entity.auditNotes = notes;
	}

	private async readEntity(id: number) {
		this.entity = Object.assign(await userModel.read(id), { userSectors: (await userModel.read(id, "userSectors")).userSectors });
	}

	private async updateUser() {
		// check password confirmation
		if (this.entity.password && this.entity.password !== this.entity.passwordConfirmation) {
			this.$toasted.error('Verifique a confirmação da senha');
			return;
		}
		try {
			await userModel.update(this.entity.id, this.entity);
			await this.readEntity(this.entity.id);
			this.$toasted.success('Usuário atualizado');
			(this.$refs.userModalTabs as ModalTabs).clearNotes();
		} catch (error) {
			console.error(error);
			this.$toasted.error(error.friendlyMessage || 'Não foi possível atualizar. Tente novamente.');
		}
		(this.$refs.userModalTabs as ModalTabs).actionCompleted();
	}

	private async deleteUser() {
		if (!this.entity.deletionReason) {
			this.$toasted.error('Selecione uma justificativa para exclusão');
			(this.$refs.userModalTabs as ModalTabs).actionCompleted();
			return;
		}

		try {
			await userModel.delete(this.entity.id, `Justificativa: ${this.entity.deletionReason}\n${this.entity.auditNotes || ''}`);
			this.$toasted.success('Usuário excluído');
			this.$emit('close');
		} catch (error) {
			this.$toasted.error('Não foi possível excluir o usuário. Tente novamente.');
			(this.$refs.userModalTabs as ModalTabs).actionCompleted();
		}
	}

	getField(key: string) {
		return this.schema.find((prop: any) => prop.key === key) || {};
	}
}
